import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=2f8f4fba&scoped=true"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"
import style0 from "./IntroVideo.vue?vue&type=style&index=0&id=2f8f4fba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f4fba",
  null
  
)

export default component.exports